/* PG Joint Buy Box
   Size selection + one-time/subscription toggle + add to cart.
   Scoped per section root. Safe to run once per section instance. */
(function () {
  'use strict';

  function init(root) {
    if (!root || root.__pgbbReady) return;
    root.__pgbbReady = true;

    var dataEl = root.querySelector('[data-pgbb-data]');
    if (!dataEl) return;

    var DATA;
    try {
      DATA = JSON.parse(dataEl.textContent);
    } catch (e) {
      return;
    }
    if (!DATA.sizes || !DATA.sizes.length) return;

    var el = {
      sizeCards: Array.prototype.slice.call(root.querySelectorAll('[data-pgbb-size]')),
      thumbs: Array.prototype.slice.call(root.querySelectorAll('[data-pgbb-thumb]')),
      stages: Array.prototype.slice.call(root.querySelectorAll('[data-pgbb-stage]')),
      switchBtn: root.querySelector('[data-pgbb-switch]'),
      labelOnce: root.querySelector('[data-pgbb-label="once"]'),
      labelSub: root.querySelector('[data-pgbb-label="sub"]'),
      benefits: root.querySelector('[data-pgbb-benefits]'),
      frequency: root.querySelector('[data-pgbb-frequency]'),
      pack: root.querySelector('[data-pgbb-pack]'),
      chews: root.querySelector('[data-pgbb-chews]'),
      ship: root.querySelector('[data-pgbb-ship]'),
      price: root.querySelector('[data-pgbb-price]'),
      perChew: root.querySelector('[data-pgbb-perchew]'),
      congrats: root.querySelector('[data-pgbb-congrats]'),
      addBtn: root.querySelector('[data-pgbb-add]'),
      ctaText: root.querySelector('.pgbb__cta-text'),
      ctaWas: root.querySelector('[data-pgbb-cta-was]'),
      ctaNow: root.querySelector('[data-pgbb-cta-now]'),
      error: root.querySelector('[data-pgbb-error]'),
      autoship: root.querySelector('[data-pgbb-autoship]'),
      as1Was: root.querySelector('[data-pgbb-as1-was]'),
      as1Now: root.querySelector('[data-pgbb-as1-now]'),
      as2Was: root.querySelector('[data-pgbb-as2-was]'),
      as2Now: root.querySelector('[data-pgbb-as2-now]')
    };

    var state = { size: 0, subscribe: true, busy: false };

    function setText(node, value) {
      if (node) node.textContent = value == null ? '' : String(value);
    }

    function currentSize() {
      return DATA.sizes[state.size] || DATA.sizes[0];
    }

    function currentPricing() {
      var s = currentSize();
      return state.subscribe && s.sellingPlan ? s.sub : s.once;
    }

    function showStage(index) {
      el.stages.forEach(function (img) {
        img.classList.toggle('is-active', Number(img.dataset.pgbbStage) === index);
      });
      el.thumbs.forEach(function (btn) {
        btn.classList.toggle('is-active', Number(btn.dataset.pgbbThumb) === index);
      });
    }

    function render() {
      var s = currentSize();
      var p = currentPricing();
      var hasPlan = Boolean(s.sellingPlan);
      var subOn = state.subscribe && hasPlan;

      // Size cards
      el.sizeCards.forEach(function (card, i) {
        var active = i === state.size;
        card.classList.toggle('is-active', active);
        card.setAttribute('aria-checked', active ? 'true' : 'false');
      });

      // Toggle chrome
      if (el.switchBtn) {
        el.switchBtn.classList.toggle('is-on', subOn);
        el.switchBtn.setAttribute('aria-checked', subOn ? 'true' : 'false');
      }
      if (el.labelSub) el.labelSub.classList.toggle('is-on', subOn);
      if (el.labelOnce) el.labelOnce.classList.toggle('is-on', !subOn);
      if (el.benefits) {
        el.benefits.classList.toggle('is-off', !subOn);
        Array.prototype.forEach.call(el.benefits.querySelectorAll('.pgbb__tick'), function (t) {
          t.innerHTML = subOn ? '&#10003;' : '&#10007;';
        });
      }

      // Frequency line follows the selected size
      setText(el.frequency, s.freq);

      // Offer row
      setText(el.pack, s.pack);
      setText(el.chews, s.chews);
      setText(el.ship, p.ship);
      setText(el.price, p.price);
      setText(el.perChew, p.perChew);

      // Congrats
      if (el.congrats) {
        var congratsCopy = subOn ? DATA.labels.congrats : DATA.labels.congratsOnce;
        setText(el.congrats, congratsCopy);
        el.congrats.hidden = !congratsCopy;
      }

      // CTA
      if (s.available === false) {
        setText(el.ctaText, DATA.labels.soldOut);
        setText(el.ctaWas, '');
        setText(el.ctaNow, '');
        if (el.addBtn) el.addBtn.disabled = true;
      } else {
        setText(el.ctaText, DATA.labels.ctaText);
        var showWas = subOn && p.compare && p.compare !== p.price;
        setText(el.ctaWas, showWas ? p.compare : '');
        setText(el.ctaNow, p.price);
        if (el.addBtn) el.addBtn.disabled = state.busy;
      }

      // Auto-ship savings panel is subscription-only
      if (el.autoship) {
        el.autoship.hidden = !subOn;
        if (subOn) {
          var wasLabel = s.autoshipWas || s.sub.compare;
          setText(el.as1Was, wasLabel);
          setText(el.as1Now, s.sub.price);
          setText(el.as2Was, wasLabel);
          setText(el.as2Now, s.sub.after);
        }
      }

      showStage(s.mediaIndex || 0);
      if (el.error) el.error.hidden = true;
    }

    // ---- Cart ----
    function openCartDrawer(sectionsPayload) {
      var drawer =
        document.querySelector('cart-drawer') ||
        document.querySelector('#CartDrawer') ||
        document.querySelector('.js-minicart, .minicart, [data-minicart]');

      if (drawer && typeof drawer.renderContents === 'function' && sectionsPayload) {
        drawer.renderContents(sectionsPayload);
        return true;
      }
      if (drawer && typeof drawer.open === 'function') {
        drawer.open();
        return true;
      }

      var notification = document.querySelector('cart-notification');
      if (notification && typeof notification.renderContents === 'function' && sectionsPayload) {
        notification.renderContents(sectionsPayload);
        return true;
      }

      document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
      document.dispatchEvent(new CustomEvent('cart:open', { bubbles: true }));
      return false;
    }

    function addToCart() {
      if (state.busy) return;
      var s = currentSize();
      if (s.available === false) return;

      state.busy = true;
      if (el.addBtn) el.addBtn.disabled = true;
      if (el.error) el.error.hidden = true;

      var body = { items: [{ id: s.id, quantity: 1 }] };
      if (state.subscribe && s.sellingPlan) {
        body.items[0].selling_plan = s.sellingPlan;
      }
      body.sections = 'cart-drawer,cart-icon-bubble,cart-notification';

      fetch(DATA.cart.addUrl + '.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify(body)
      })
        .then(function (res) {
          return res.json().then(function (json) {
            if (!res.ok) throw new Error(json.description || json.message || 'add_failed');
            return json;
          });
        })
        .then(function (json) {
          if (DATA.cart.redirect) {
            window.location.href = DATA.cart.cartUrl;
            return;
          }
          var opened = openCartDrawer(json.sections);
          if (!opened) window.location.href = DATA.cart.cartUrl;
        })
        .catch(function () {
          if (el.error) {
            setText(el.error, DATA.labels.errorText);
            el.error.hidden = false;
          }
        })
        .then(function () {
          state.busy = false;
          if (el.addBtn) el.addBtn.disabled = false;
        });
    }

    // ---- Events ----
    el.sizeCards.forEach(function (card) {
      card.addEventListener('click', function () {
        state.size = Number(card.dataset.pgbbSize) || 0;
        render();
      });
    });

    el.thumbs.forEach(function (btn) {
      btn.addEventListener('click', function () {
        showStage(Number(btn.dataset.pgbbThumb) || 0);
      });
    });

    if (el.switchBtn) {
      el.switchBtn.addEventListener('click', function () {
        state.subscribe = !state.subscribe;
        render();
      });
    }

    if (el.addBtn) el.addBtn.addEventListener('click', addToCart);

    render();
  }

  function boot() {
    Array.prototype.forEach.call(document.querySelectorAll('[data-pgbb-root]'), init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  // Theme editor re-render
  document.addEventListener('shopify:section:load', function (e) {
    var root = e.target.querySelector('[data-pgbb-root]');
    if (root) init(root);
  });
})();